import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import UserApi from "../services/userApi";
import AppApi from "../services/appApi";
import LoginApi from "../services/loginApi"
import {
    INIT_APP_FAIL, VARIFY_OTP_RESPONSE, VARIFY_OTP_RESPONSE_FAIL, MYZONE_RESPONSE, MYZONE_RESPONSE_FAIL,
    VALIDATE_USER_RESPONSE, VALIDATE_USER_RESPONSE_FAIL, USER_LOG_RESPONSE, USER_LOG_RESPONSE_FAIL,
    LOGIN_ATTEMPT_RESPONSE, LOGIN_ATTEMPT_RESPONSE_FAIL, INIT_APP_RESPONSE,
    GET_STRATEGY_FAIL, GET_STRATEGY_RESPONSE, REPORT_SEND_RESPONSE, REPORT_SEND_FAIL,
    USER_ID_RESPONSE, GET_ACCOUNT_PERFORMANCE_FAILED, GET_ACCOUNT_PERFORMANCE_RESPONSE,
    GET_CAPITAL_MOVEMENT_RESPONSE, GET_CORPORATE_ACTION_RESPONSE, GET_CORPORATE_ACTION_FAILED,
    GET_CAPITAL_MOVEMENT_FAILED, GET_DEBIT_NOTE_RESPONSE, GET_DEBIT_NOTE_FAILED, GET_TAXIBLE_GAIN_RESPONSE,
    GET_TAXIBLE_GAIN_FAILED, GET_HOLDING_STATEMENT_RESPONSE, GET_HOLDING_STATEMENT_FAILED,
    GET_AUDIT_REPORT_YEARS_RESPONSE, GET_AUDIT_REPORT_YEARS_FAILED, GET_AUDIT_REPORT_RESPONSE,
    GET_AUDIT_REPORT_FAILED,
    GET_QUERY_CATEGORY_RESPONSE,
    GET_QUERY_CATEGORY_FAILED,
    GET_QUERY_SUB_CATEGORY_RESPONSE,
    GET_QUERY_SUB_CATEGORY_FAILED,
    RAISE_QUERY_CLIENT_PMS_RESPONSE,
    RAISE_QUERY_CLIENT_PMS_FAILED,
    RAISE_QUERY_CLIENT_MF_RESPONSE,
    RAISE_QUERY_CLIENT_MF_FAILED,
    RAISE_QUERY_FAILED,
    RAISE_QUERY_RESPONSE,
    GET_AUDIT_REPORT_STRATEGY_RESPONSE,
    GET_AUDIT_REPORT_STRATEGY_FAILED,
    PMS_GET_AUDIT_REPORT_STRATEGY_FAILED,
    PMS_GET_AUDIT_REPORT_STRATEGY_RESPONSE,
    BITALY_LINK_RESPONSE,
    BITALY_LINK_FAILED, GET_ACCOUNT_STATEMENT_RESPONSE, GET_ACCOUNT_STATEMENT_FAILED, GET_MF_ACCOUNT_STATEMENT_RESPONSE, GET_MF_ACCOUNT_STATEMENT_FAILED,
    GET_MF_CAPITAL_GAIN_LOSS_FAILED, GET_MF_CAPITAL_GAIN_LOSS_RESPONSE, CHECK_PMS_DIT_PAN_RESPONSE, CHECK_PMS_DIT_PAN_FAILED,
    CHECK_AIF_DIT_PAN_FAILED, CHECK_AIF_DIT_PAN_RESPONSE, GET_ACCOUNT_PERFORMANCE_GROUP_WIS_FAILED, GET_ACCOUNT_PERFORMANCE_GROUP_WIS_RESPONSE,
    GET_FRACTION_LEDGER, GET_FRACTION_LEDGER_RESPONSE, GET_FRACTION_LEDGER_FAILED, PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_RESPONSE,
    PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_FAILED,
    CHECK_MF_PAN_DIST_RESPONSE,
    CHECK_MF_PAN_DIST_FAILED,
    MYZONE_DATA_RESPONSE
} from '../redux/types/initApp';
import { GET_DIT_USER_DETAILS_SUCCESS, GET_DIT_USER_DETAILS_FAILURE } from "../redux/types/getDITUserDetails";
// import { AUTHENTICATE_USER_RESPONSE } from '../redux/types/authenticate';
let api = new UserApi();
let api2 = new AppApi()
let ApiLogin = new LoginApi()
export function* initApp({ type, resolve, payload }) {
    let responsePayload = {};

    try {
        let { data } = yield api2.init(payload);
        if (data.sucess) {
            responsePayload = data.data;
            yield put({ type: INIT_APP_RESPONSE, payload: responsePayload })

            resolve && resolve()
        }

    } catch (e) {
        yield put({ type: INIT_APP_FAIL })
    }
}


export function* varifyOtp({ type, resolve, payload }) {
    let responsePayload = {};
    try {
        let { data } = yield api.verifyOtp(payload);
        if (data.success) {
            yield put(push('/report'));
            responsePayload = data.data;
            yield put({ type: VARIFY_OTP_RESPONSE, payload: responsePayload })

            resolve && resolve()
        }
    } catch (e) {
        yield put({ type: VARIFY_OTP_RESPONSE_FAIL })
    }
}

export function* getMyzone({ type, resolve, payload }) {

    yield put({ type: USER_ID_RESPONSE, payload: payload.username })

    let responsePayload = {};

    try {

        let { data } = yield api.myzone(payload);
        if (data.success) {
            responsePayload = data.data;
            yield put({ type: MYZONE_RESPONSE, payload: responsePayload })
            // yield put(push('/report'));
            resolve && resolve(responsePayload)
        } else {
            yield put({ type: MYZONE_RESPONSE_FAIL })
            resolve && resolve(data)
        }

    } catch (e) {
        yield put(push('/'));
        yield put({ type: MYZONE_RESPONSE_FAIL })
        resolve && resolve(e)

    }
}

export function* validateUser({ type, resolve, payload }) {
    let responsePayload = "";
    try {
        let { data } = yield api.validateUser(payload);
        console.log(`data in validate user`, data.success)
        if (data.success) {
            responsePayload = data
            yield put({ type: VALIDATE_USER_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
            // if (window.location.pathname === "/") {
            //     yield put(push('/report'));
            // }
        } else {
            yield put(push('/'));
            yield put({ type: VALIDATE_USER_RESPONSE_FAIL })
            resolve && resolve(data)
        }

    } catch (e) {
        yield put(push('/'));
        yield put({ type: VALIDATE_USER_RESPONSE_FAIL })
        resolve && resolve(e)

    }
}

export function* userLogs({ type, resolve, payload }) {
    let responsePayload = "";
    try {
        let { data } = yield api.userLog(payload);
        console.log(`data in userLog user`, data)
        if (data.success) {
            responsePayload = data.data[0].LogID;
            yield put({ type: USER_LOG_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }

    } catch (e) {
        console.log(`error in user log`, e)
        yield put(push('/'));
        yield put({ type: USER_LOG_RESPONSE_FAIL })


    }
}


export function* loginAttempt({ type, resolve, payload }) {
    let responsePayload = "";
    try {
        let { data } = yield api.loginAttempt(payload);
        if (data.success) {
            responsePayload = data.data
            yield put({ type: LOGIN_ATTEMPT_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }

    } catch (e) {
        yield put({ type: LOGIN_ATTEMPT_RESPONSE_FAIL })
        resolve && resolve(e)

    }
}

export function* getStratergy({ type, resolve, payload }) {
    let responsePayload = "";
    let responsePayloadError = "";

    try {
        let { data } = yield api.getStratergy(payload);
        let resData = (data?.data && data.data.hasOwnProperty('success')) ? data.data : data;
        responsePayloadError = resData;
        console.log("data get strategy saga", resData);
        if (resData.success) {
            responsePayload = resData.data
            yield put({ type: GET_STRATEGY_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        } else {
            console.log("eroor get strategy saga");
            yield put({ type: GET_STRATEGY_FAIL })
            resolve && resolve(resData)
        }

    } catch (e) {
        console.log("eroor get strategy saga", e);
        yield put({ type: GET_STRATEGY_FAIL })
        resolve && resolve(responsePayloadError)
    }
}

export function* reportSend({ type, resolve, payload }) {
    let responsePayload = "";
    let responsePayloadError = "";

    try {
        let { data } = yield api.reportSend(payload);
        console.log("Report send response", data);
        responsePayloadError = data;
        if (data.success) {
            responsePayload = data

            yield put({ type: REPORT_SEND_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        } else {
            yield put({ type: REPORT_SEND_FAIL })
            resolve && resolve(data)
        }

    } catch (e) {
        yield put({ type: REPORT_SEND_FAIL })
        resolve && resolve(responsePayloadError)

    }
}


export function* getUserID({ type, resolve, payload }) {

    yield put({ type: USER_ID_RESPONSE, payload: payload })
    resolve && resolve()

}

export function* myZoneNewData({ type, resolve, payload }) {

    yield put({ type: MYZONE_RESPONSE, payload: payload })
    resolve && resolve()

}

export function* getAccountPerformance({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.accountPerformance(payload);
        console.log("responsePayload getAccountPerformance", data)
        if (data.success) {
            let responseData = data.data;
            responsePayload.success = data.success;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_ACCOUNT_PERFORMANCE_RESPONSE, payload: responsePayload, })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_ACCOUNT_PERFORMANCE_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_ACCOUNT_PERFORMANCE_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* getCapitalMovement({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetCapitalMovement(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload.success = data.success;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_CAPITAL_MOVEMENT_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_CAPITAL_MOVEMENT_FAILED, payload: responsePayload })
        }
    } catch (e) {
        resolve && resolve(responsePayload)
        yield put({ type: GET_CAPITAL_MOVEMENT_FAILED, payload: responsePayload })

    }
}

export function* getCorporateAction({ payload, resolve }) {
    let responsePayload = {};

    try {
        let { data } = yield api.GetCorporateAction(payload);

        if (data.success) {
            let responseData = data.data;
            responsePayload.success = data.success;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_CORPORATE_ACTION_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_CORPORATE_ACTION_FAILED, payload: responsePayload })
        }
    } catch (e) {
        resolve && resolve(responsePayload)
        yield put({ type: GET_CORPORATE_ACTION_FAILED, payload: responsePayload })

    }
}

export function* getDebitNote({ payload, resolve }) {
    let responsePayload = {};

    try {
        let { data } = yield api.GetDebitNote(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload.success = data.success;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_DEBIT_NOTE_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_DEBIT_NOTE_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_DEBIT_NOTE_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* getTaxaibleGain({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetTaxaibleGain(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload.success = data.success;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_TAXIBLE_GAIN_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            yield put({ type: GET_TAXIBLE_GAIN_FAILED, payload: responsePayload })
            resolve && resolve(data)

        }
    } catch (e) {
        yield put({ type: GET_TAXIBLE_GAIN_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)

    }
}

export function* getHoldingStatement({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetHoldingStatement(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload.success = data.success;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_HOLDING_STATEMENT_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_HOLDING_STATEMENT_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_HOLDING_STATEMENT_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* getAuditReportYears({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetAuditReportYears(payload);
        if (data.success) {

            let responseData = data.data;
            responsePayload = responseData;
            yield put({ type: GET_AUDIT_REPORT_YEARS_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_AUDIT_REPORT_YEARS_FAILED, payload: responsePayload })
        }
    } catch (e) {
        resolve && resolve(responsePayload)
        yield put({ type: GET_AUDIT_REPORT_YEARS_FAILED, payload: responsePayload })

    }
}

export function* getAuditReport({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetAuditReport(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload.pdfUrl = responseData.url;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_AUDIT_REPORT_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_AUDIT_REPORT_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_AUDIT_REPORT_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* getAuditStratergy({ payload, resolve }) {
    let responsePayload = {};
    console.log("payload", payload)
    try {
        let { data } = yield api.GetAuditReportStratergy(payload);
        if (data.success) {

            let responseData = data.data;
            responsePayload = responseData;
            yield put({ type: GET_STRATEGY_RESPONSE, payload: responsePayload })
            yield put({ type: GET_AUDIT_REPORT_STRATEGY_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_AUDIT_REPORT_STRATEGY_FAILED, payload: responsePayload })
        }
    } catch (e) {
        resolve && resolve(responsePayload)
        yield put({ type: GET_AUDIT_REPORT_STRATEGY_FAILED, payload: responsePayload })

    }
}

export function* bitalyLink({ payload, resolve }) {
    let responsePayload = {};
    let newpayload ={...payload,"Channel" : "MOAMCL"}
    console.log("payload", payload)

    try {
        let { data } = yield api.bitlyLink(newpayload);
        if (data.success) {

            let responseData = data.data;
            yield put({ type: BITALY_LINK_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: BITALY_LINK_FAILED, payload: responsePayload })
        }
    } catch (e) {
        resolve && resolve(responsePayload)
        yield put({ type: BITALY_LINK_FAILED, payload: responsePayload })

    }
}

export function* GetAccountStatement({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetAccountStatement(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_ACCOUNT_STATEMENT_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_ACCOUNT_STATEMENT_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_ACCOUNT_STATEMENT_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* GetMFAccountStatement({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetMFAccountStatement(payload);
        if (data.success) {
            let responseData = data.data;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_MF_ACCOUNT_STATEMENT_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_MF_ACCOUNT_STATEMENT_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_MF_ACCOUNT_STATEMENT_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* GetMFcapitalGainLoss({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetMFcapitalGainLoss(payload);
        console.log("data", data);

        if (data.success) {
            console.log("data", data);
            let responseData = data.data;
            responsePayload = responseData;

            yield put({ type: GET_MF_CAPITAL_GAIN_LOSS_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_MF_CAPITAL_GAIN_LOSS_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_MF_CAPITAL_GAIN_LOSS_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* CheckPMSDITPan({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield ApiLogin.CheckPMSDITPan(payload);
        console.log("dataData", data);

        if (data.success) {
            console.log("data", data);
            let responseData = data.data;
            responsePayload = responseData
            yield put({ type: CHECK_PMS_DIT_PAN_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: CHECK_PMS_DIT_PAN_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: CHECK_PMS_DIT_PAN_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}
export function* GetDITUserDetails({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield ApiLogin.GetDITUserDetails(payload);
        console.log("data", data);

        if (data.success) {
            responsePayload = data.data;
            yield put({ type: MYZONE_RESPONSE, payload: responsePayload })
            yield put(push('/report'));
            resolve && resolve(responsePayload)
        } else {
            yield put({ type: MYZONE_RESPONSE_FAIL })
            resolve && resolve(data)
        }

    } catch (e) {
        yield put({ type: MYZONE_RESPONSE_FAIL })
        resolve && resolve(e)

    }
}

export function* CheckAIFDITPan({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield ApiLogin.CheckAIFDITPan(payload);
        console.log("data", data);

        if (data.success) {
            console.log("data", data);
            let responseData = data.data;
            responsePayload = responseData
            yield put({ type: CHECK_AIF_DIT_PAN_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: CHECK_AIF_DIT_PAN_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: CHECK_AIF_DIT_PAN_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}
// Utils

function formatPMSList(data) {
    let processedList = data.map(({ pms_Code, instrument_Name }) => {
        return { label: instrument_Name, value: pms_Code }
    })
    return processedList;
}

//pms audit report strategy
export function* PMSgetAuditStratergy({ payload, resolve }) {
    let responsePayload = {};
    console.log("payload", payload)
    try {
        let { data } = yield api.PMSGetAuditReportStrategy(payload);
        if (data.success) {

            let responseData = data.data;
            console.log("responseData", responseData);
            responsePayload = responseData;
            // yield put({ type: GET_STRATEGY_RESPONSE, payload: responsePayload })
            yield put({ type: PMS_GET_AUDIT_REPORT_STRATEGY_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: PMS_GET_AUDIT_REPORT_STRATEGY_FAILED, payload: responsePayload })
        }
    } catch (e) {
        resolve && resolve(responsePayload)
        yield put({ type: PMS_GET_AUDIT_REPORT_STRATEGY_FAILED, payload: responsePayload })

    }
}

export function* GetAccountPerformanceGroupwis({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.GetAccountPerformanceGroupwis(payload);
        console.log("data", data);

        if (data.success) {
            console.log("data", data);
            let responseData = data.data;
            responsePayload = responseData;
            yield put({ type: GET_ACCOUNT_PERFORMANCE_GROUP_WIS_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
        else {
            resolve && resolve(data)
            yield put({ type: GET_ACCOUNT_PERFORMANCE_GROUP_WIS_FAILED, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: GET_ACCOUNT_PERFORMANCE_GROUP_WIS_FAILED, payload: responsePayload })
        resolve && resolve(responsePayload)
    }
}

export function* getFractionLedger({ payload, resolve }) {
    let responsePayload = {};
    try {
        //yield put({ type: START_LOADING_RESPONSE, payload: responsePayloadLoader })
        let { data } = yield api.GetFractionLedger(payload);
        if (data.success) {
            //yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            let responseData = data.data;
            responsePayload.success = data.success;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: GET_FRACTION_LEDGER_RESPONSE, payload: responsePayload, })
            resolve && resolve(responsePayload)
            console.log("datain fraction ledger", responsePayload);

        }
        else {
            resolve && resolve(data)
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            yield put({ type: GET_FRACTION_LEDGER_FAILED, payload: responsePayload })
        }
    } catch (e) {
        // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
        yield put({ type: GET_FRACTION_LEDGER_FAILED, payload: responsePayload })

    }
}

export function* pmsRealisedCapitalGainLossReport({ payload, resolve }) {
    let responsePayload = {};

    try {

        let { data } = yield api.PMSRealisedCapitalGainLossReport(payload);

        if (data.success) {
            let responseData = data.data;
            responsePayload.success = data.success;
            responsePayload.excelUrl = responseData.excelUrl;
            responsePayload.pdfUrl = responseData.pdfUrl;
            responsePayload.isS3 = responseData.isS3;
            yield put({ type: PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
            console.log("response from RealisedCapitalGainLoss", responsePayload);
        }
        else {
            resolve && resolve(data)
            yield put({ type: PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_FAILED, payload: responsePayload })
        }
    } catch (e) {

        yield put({ type: PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_FAILED, payload: responsePayload })

    }
}

export function* CheckMFPanDist({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield ApiLogin.CheckMFPanDist(payload);
        console.log("response from CheckMFPanDist", data);
        if (data.success) {
            let responseData = data.data;
            responsePayload = responseData;
            yield put({ type: CHECK_MF_PAN_DIST_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        } else {
            resolve && resolve(data)
            yield put({ type: CHECK_MF_PAN_DIST_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: CHECK_MF_PAN_DIST_FAILED, payload: e.toString() })
    }
}
